import styled, { css } from 'styled-components';
export const StepperStyled = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    fill: currentColor;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  input {
    border: 0;
    outline: 0;
    text-align: center;
    margin: 4px;
    height: 40px;
    padding: 0;
    color: ${({ theme }) => theme.ColorGrey800};
    -webkit-text-fill-color: ${({ theme }) => theme.ColorGrey800};
    width: 40px;
    background-color: transparent;
  }
`;
const getColor = (isDisabled, theme, colorScheme) => {
    if (colorScheme === 'brand-tertiary') {
        return isDisabled
            ? theme.ColorInputDisabledOutline
            : theme.ColorInputDefaultOutline;
    }
    if (colorScheme === 'brand-primary') {
        return isDisabled
            ? theme.ColorComponentStepperBrandedStepperDisabled
            : theme.ColorComponentStepperBrandedStepper;
    }
};
export const StyledButtonContainer = styled.div `
  button {
    ${({ colourScheme, isDisabled, theme }) => {
    if (colourScheme === 'brand-primary') {
        const color = getColor(isDisabled, theme, 'brand-primary');
        return css `
          opacity: unset;
          border-color: ${color};
          &:hover,
          &:focus {
            border-color: ${color};
          }
          svg {
            color: ${color};
          }
        `;
    }
    if (colourScheme === 'brand-tertiary') {
        const borderColor = getColor(isDisabled, theme, 'brand-tertiary');
        return css `
          border-width: 1px;
          border-color: ${borderColor};
          &:hover,
          &:focus {
            border-color: ${borderColor};
          }
        `;
    }
}}
  }
`;
//# sourceMappingURL=stepper.styles.js.map